export const SET_ACCEPTED = "SET_ACCEPTED";
